/**
 * Configuración de pesos de rúbrica académica
 * 
 * Este archivo centraliza los pesos fijos de la rúbrica de evaluación académica.
 * Los pesos se aplican uniformemente a todas las lecciones.
 * 
 * Para cambiar los pesos, simplemente modifica los valores en RUBRIC_WEIGHTS.
 * La suma de todos los pesos debe ser 100.
 */

export interface RubricWeights {
  'Fluidez comunicativa': number;
  'Vocabulario': number;
  'Gramática': number;
  'Pronunciación': number;
  [key: string]: number;
}

/**
 * Pesos fijos de la rúbrica de evaluación
 * Cada categoría tiene el mismo peso (25% cada una)
 */
export const RUBRIC_WEIGHTS: RubricWeights = {
  'Fluidez comunicativa': 25,
  'Vocabulario': 25,
  'Gramática': 25,
  'Pronunciación': 25
};
